"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sourceSelector = sourceSelector;
function sourceSelector(state) {
  return state.source;
}